import ErrorList from "common/ui/ErrorList";
import React from "react";
import { Container } from "react-bootstrap";
import { Trader } from "./trader";

export type AddTraderDetailsProps = {
  trader: Trader;
  errors: string[];
};

const AddTraderConfirmation = (props: AddTraderDetailsProps) => (
  <Container>
    <table className="table table-striped">
      <tbody>
        <tr>
          <td>
            <h6>First Name</h6>
          </td>
          <td className="font-weight-bold">{props.trader.firstName}</td>
        </tr>
        <tr>
          <td>
            <h6>Last Name</h6>
          </td>
          <td className="font-weight-bold">{props.trader.lastName}</td>
        </tr>
        <tr>
          <td>
            <h6>Email</h6>
          </td>
          <td className="font-weight-bold">{props.trader.email}</td>
        </tr>
        <tr>
          <td>
            <h6>Phone Number</h6>
          </td>
          <td className="font-weight-bold">{props.trader.phone}</td>
        </tr>
        <tr>
          <td>
            <h6>Cell Phone (to receive text alerts)</h6>
          </td>
          <td className="font-weight-bold">{props.trader.cellPhone}</td>
        </tr>
      </tbody>
    </table>
    <ErrorList errors={props.errors}>
        <h3>Errors</h3>
    </ErrorList>
  </Container>
);

export default AddTraderConfirmation;
